import { AnyAction } from 'redux';
import { SelectedWhatsappTierRange } from 'src/api/meta/whatsappTierRangesApi';
import { GetAvailableWhatsappTier, GetWhatsappTierRange } from 'src/types/meta/whatsappTiers';

export const tabs = { config: 0, pricing: 1 };

interface WhatsappState {
  whatsappTierRanges: GetWhatsappTierRange;
  whatsappTierRangesLoading: boolean;
  selectedWhatsappTierRanges: Partial<SelectedWhatsappTierRange>;
  selectedWhatsappTierRangesLoading: boolean;
  formOpen: boolean;
  missingTierRangesDialogOpen: boolean;
  selectedCountriesTierRanges: GetAvailableWhatsappTier;
  selectedAvailableWhatsappTierRangesLoading: boolean;
}

const initialState: WhatsappState = {
  whatsappTierRanges: {},
  whatsappTierRangesLoading: false,
  selectedWhatsappTierRanges: {},
  selectedWhatsappTierRangesLoading: false,
  formOpen: false,
  missingTierRangesDialogOpen: false,
  selectedCountriesTierRanges: {},
  selectedAvailableWhatsappTierRangesLoading: false,
};

export default function reducer(state: WhatsappState = initialState, action: AnyAction): WhatsappState {
  switch (action.type) {
    case 'SET_WHATSAPP_TIER_RANGES': {
      return {
        ...state,
        whatsappTierRanges: action.whatsappTierRanges,
      };
    }
    case 'SET_WHATSAPP_TIER_RANGES_LOADING': {
      return {
        ...state,
        whatsappTierRangesLoading: action.payload,
      };
    }
    case 'SET_WHATSAPP_SELECTED_TIER_RANGES_LOADING': {
      return {
        ...state,
        selectedWhatsappTierRangesLoading: action.payload,
      };
    }
    case 'SET_SELECTED_WHATSAPP_TIER_RANGES': {
      return {
        ...state,
        selectedWhatsappTierRanges: action.payload,
      };
    }
    case 'UPDATE_TIER_RANGES': {
      return {
        ...state,
        whatsappTierRanges: action.payload,
      };
    }
    case 'SET_SELECTED_WHATSAPP_TIER_RANGES_FORM_OPEN': {
      return {
        ...state,
        formOpen: action.formOpen,
      };
    }
    case 'SET_MISSING_TIER_RANGES_DIALOG_OPEN': {
      return {
        ...state,
        missingTierRangesDialogOpen: action.payload,
      };
    }
    case 'SET_WHATSAPP_AVAILABLE_SELECTED_TIER_RANGES_LOADING': {
      return {
        ...state,
        selectedAvailableWhatsappTierRangesLoading: action.payload,
      };
    }
    case 'SET_AVAILABLE_SELECTED_WHATSAPP_TIER_RANGES': {
      return {
        ...state,
        selectedCountriesTierRanges: action.payload,
      };
    }
    default:
      return {
        ...state,
      };
  }
}
